export default function FinalCtaSection() {
  return (
    <section className="relative min-h-[80vh] flex">
      {/* Left - Image */}
      <div className="hidden lg:flex w-1/2 relative bg-background-200 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20scene%20with%20premium%20leather%20handbag%20designer%20sneakers%20and%20gold%20accessories%20styled%20on%20warm%20cream%20marble%20surface%2C%20soft%20natural%20window%20light%20from%20left%2C%20editorial%20luxury%20photography%2C%20beige%20and%20sand%20tones%2C%20sophisticated%20contemporary%20composition%2C%20high%20detail%20textures%2C%20aspirational%20shopping%20aesthetic&width=1000&height=1200&seq=cta-v2-final-z1&orientation=portrait"
          alt="Hoobuy Spreadsheet - Comece agora"
          title="HoobuySpreadsheet - Acesse as Melhores Planilhas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute top-12 left-12 z-10">
          <span className="text-xs font-medium text-foreground-800 bg-white/90 px-4 py-1.5 rounded-full whitespace-nowrap">
            Comece agora
          </span>
        </div>
        <div className="absolute bottom-12 left-12 z-10">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-none">
            Acesse
          </h2>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-none mt-1">
            Hoobuy
          </h2>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-none mt-1">
            Spreadsheet
          </h2>
        </div>
      </div>

      {/* Right - CTA */}
      <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-16 py-20">
        <div className="max-w-md w-full text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Compre com<br />
            <span className="italic font-normal">Inteligência</span>
          </h2>
          <p className="mt-8 text-foreground-600 leading-relaxed text-sm md:text-base">
            Acesse agora o <strong className="text-foreground-900">HoobuySpreadsheet atualizado 2026</strong> e descubra os melhores produtos antes que esgotem. Planilhas organizadas, links verificados e economia real em cada compra.
          </p>

          <div className="mt-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 h-16 px-10 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>

          <p className="mt-6 text-xs text-foreground-400">
            Mais de 10.000 produtos organizados em 14 categorias. Atualização diária.
          </p>

          {/* Mobile image preview */}
          <div className="mt-12 lg:hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Fashion%20accessories%20and%20sneakers%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%2C%20beige%20and%20sand%20tones%2C%20sophisticated%20clean%20composition%2C%20elegant%20lifestyle%20aesthetic%2C%20high%20detail%20textures&width=800&height=500&seq=cta-v2-mobile-z2&orientation=landscape"
              alt="Hoobuy Spreadsheet"
              className="w-full h-auto rounded-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}